import BigNumber from 'bignumber.js';
import React from 'react';

import type { Transaction } from 'types/api/transaction';

import config from 'configs/app';
import { balance, number } from 'ui/home/saba/format';
import styles from 'ui/home/saba/SabaHome.module.css';

type Props = Pick<Transaction, 'token_transfer_summary' | 'value'>;

function tokenLine(summary: NonNullable<Transaction['token_transfer_summary']>): React.ReactNode {
  const label = summary.token?.symbol || summary.token?.name || 'توکن';
  const total = summary.total;
  let amount = '۱';

  if (total && 'value' in total) {
    const decimals = Number(total.decimals ?? summary.token?.decimals ?? 0);
    amount = balance(total.value, Number.isFinite(decimals) ? decimals : 0);
  }

  return (
    <span className={ styles.tokenValue }>
      <bdi dir="ltr">{ amount } { label }</bdi>
      { summary.additional_token_count > 0 && (
        <> + { number(summary.additional_token_count, 0) } توکن دیگر</>
      ) }
    </span>
  );
}

export default function TransactionValue({ value, token_transfer_summary: tokenSummary }: Props) {
  const coin = config.chain.currency.symbol || 'SABA';
  const decimals = config.chain.currency.decimals;
  const hasNativeValue = new BigNumber(value || 0).isGreaterThan(0);

  if (!hasNativeValue && !tokenSummary) return <span>—</span>;

  return (
    <span className={ styles.transactionValue }>
      { hasNativeValue && <bdi dir="ltr">{ balance(value, decimals) } { coin }</bdi> }
      { tokenSummary && tokenLine(tokenSummary) }
    </span>
  );
}
